/* ------------------------------------------------------------------ */
/*  Athena screener payload (used by WellnessCheck)                    */
/* ------------------------------------------------------------------ */

export interface ScreenerSubmitPayload {
  questionnaireId?: number | string;
  templateId: number | string;
  questions: { questionid: number | string; answer: string }[];
  score: string;
}

/* ------------------------------------------------------------------ */
/*  Shared question / section / questionnaire types                    */
/*  Compatible with both Athena (WellnessCheck) and adhoc screeners    */
/* ------------------------------------------------------------------ */

export interface ScreenerOption {
  optionid: string;
  optiontext: string;
  optionvalue: string;
}

export interface ScreenerQuestion {
  questionid: number | string;
  question: string;
  possibleanswers?: string[] | null;
  key: string;
  questiontype?: string;
  required?: boolean;
  options?: ScreenerOption[];
}

export interface ScreenerSection {
  headertext: string;
  sectionname?: string;
  questionlist: ScreenerQuestion[];
}

export interface ScreenerQuestionnaire {
  questionnaireid: number;
  templateid: number | string;
  name: string;
  sections: ScreenerSection[];
  screenerTemplateId?: string;
  stepStatus?: string;
  screenertype?: string;
  templatename?: string;
}

/* ------------------------------------------------------------------ */
/*  Athena response shape (used by WellnessCheck)                      */
/* ------------------------------------------------------------------ */

export interface ScreenerResponse {
  questionnairescreeners: ScreenerQuestionnaire[];
}

/* ------------------------------------------------------------------ */
/*  Adhoc screener API types (used by PatientScreeners)                */
/* ------------------------------------------------------------------ */

export interface AdhocScreenerApiResponse {
  success: boolean;
  message?: string;
  errorCode?: string | null;
  data: {
    workflowId: string;
    workflowStatus: string;
    screeners: AdhocScreenerItem[];
  } | null;
}

export interface AdhocScreenerItem {
  screenerTemplateId: string;
  stepStatus: string;
  name: string;
  templateid: number | null;
  templatetype: string;
  scoringstatus: string;
  sections: ScreenerSection[];
  metaquestions: unknown[];
  documentids: unknown[];
}

export interface AdhocSubmitPayload {
  screenerTemplateId: string;
  answers: { questionid: number | string; answer: string }[];
  score?: string;
}

export const SUBMITTED_STATUSES = ['COMPLETED', 'SYNCED', 'SYNC_FAILED'] as const;

/* ------------------------------------------------------------------ */
/*  Helpers                                                             */
/* ------------------------------------------------------------------ */

const TEXT_INPUT_TYPES = new Set(['FREE_TEXT', 'NUMERIC']);

export function isTextInputQuestion(q: ScreenerQuestion): boolean {
  return !!q.questiontype && TEXT_INPUT_TYPES.has(q.questiontype);
}
